module.exports = __webpack_public_path__ + "static/media/basketball.22f7a413.png";